import { useEffect } from 'react';

import { Route, BrowserRouter as Router, Switch, useHistory } from 'react-router-dom';

import { Login, Register } from '@/pages/Auth';
import asyncComponentLoader from '@/utils/react/loader';

import AuthedApp from './AuthedApp';
import { trackPageView } from './utils/analytics/google';

// We need to delay the tracking of the page view to give React Helmet time to initialize
// See https://github.com/nfl/react-helmet/issues/189
const delayedPageTrack = () =>
  setTimeout(() => {
    trackPageView();
  }, 3000);

function App() {
  const history = useHistory();

  // Implementation taken from:
  // https://www.sheshbabu.com/posts/automatic-pageview-tracking-using-react-router/
  useEffect(() => {
    if (history) {
      delayedPageTrack();
      history.listen(delayedPageTrack);
    }
  }, [history]);

  return (
    <Router>
      <Switch>
        <Route path="/login/" component={Login} />
        <Route
          path="/signup/:inviteId/"
          component={asyncComponentLoader(() => import('@/pages/Onboarding'))}
        />
        <Route path="/signup/" component={Register} />
        <Route
          path="/waiting_room"
          component={asyncComponentLoader(() => import('@/pages/Auth/WaitingRoom'))}
        />
        <Route
          path="/playground/:modelFamily/:modelName?"
          component={asyncComponentLoader(() => import('@/pages/Playground'))}
        />
        <Route component={AuthedApp} />
      </Switch>
    </Router>
  );
}

export default App;
